import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getProviderCategories, StateStatus } from '@guryou/redux';
const useProviderCategories = _ref => {
  let {
    providerId
  } = _ref;
  const dispatch = useDispatch();
  const {
    data,
    status,
    version,
    entity,
    request
  } = useSelector(state => state.categories.providers);
  useEffect(() => {
    if (status === StateStatus.NOT_INITIALIZED || status === StateStatus.LOADED && request.providerId !== providerId) {
      dispatch(getProviderCategories({
        providerId
      }));
    }
  }, [data, dispatch, providerId, request, status]);
  return {
    data: data || [],
    status,
    version,
    entity
  };
};
export default useProviderCategories;